import { getItem, setItem } from 'services/localStorage/cache'

import { fetchData as fetchCustomer } from '../services/api/core/customer'
import { fetchData as fetchCustomerLeads } from '../services/api/core/customer/leads'

const onlyNumbers = (text: string) => text.replace(/\D/g, '')

async function fetchRecurrentLead(cpf: string): Promise<{
  isRecurrent: boolean
}> {
  const cacheKey = `fetchRecurrentLeads:${onlyNumbers(cpf)}`
  const cacheValue = getItem(cacheKey)

  if (cacheValue) {
    return cacheValue
  }

  try {
    const { customer } = await fetchCustomer(onlyNumbers(cpf))

    const leads = await fetchCustomerLeads(customer.id)

    const data = {
      isRecurrent: leads.length > 1,
    }

    setItem(cacheKey, data)
    return data
  } catch (error) {
    return {
      isRecurrent: false,
    }
  }
}

export { fetchRecurrentLead }
